import { PricelistPeriodListPage } from '@/features/pricelist-period/pages/PricelistPeriodListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/period/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistPeriodListPage,
})
